import extractQuestionnaireData from '../../data_management/extractQuestionnaireData';

export default class StartInvestigationController {
  constructor($scope, initialDataInteractor, eventsService, localize, emailInteractor, workspaceId, close) {
    this.$scope = $scope;
    this.initialDataInteractor = initialDataInteractor;
    this.eventsService = eventsService;
    this.localize = localize;
    this.emailInteractor = emailInteractor;
    this.workspaceId = workspaceId;
    this.close = close;

    this.initialDataInteractor.executeWithInitializedSession(() => {
      $scope.$evalAsync(() => {
        this.questionnaires = extractQuestionnaireData(initialDataInteractor);
        this.searchableQuestionnaires = this.questionnaires.map(q => {return {label: q.name, id: q.id}});
        // console.log(this.searchableQuestionnaires);
      });
    });

  }

  selectQuestionnaire(questionnaire) {
    this.questionnaire = this.questionnaires.find(q => q.id == questionnaire.id);
  }

  sendEmail() {
    return this.emailInteractor.sendQuestionnaireEmailToWorkspace(this.questionnaire.id, this.workspaceId, this.message, this.openReports)
      .then(() => {
        this.eventsService.publishSystemMessage('Investigation successfully created');
        this.close();
      }, err => {
        this.eventsService.publishSystemError(`Failed to create investigation:  ${err.message}`);
      });
  };
}